import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AddClearButtonsProps {
  reset?: (params?: any) => void;
  callBackFunc?: (event?: React.MouseEvent<HTMLElement>) => void;
  handleSubmit?: any;
  disabled?: boolean;
  resetParams?: {};
  fullWidth?: boolean;
  other?: any;
  isButton?: boolean;
}

const AddClearButtons: React.FC<AddClearButtonsProps> = ({
  reset,
  callBackFunc,
  handleSubmit,
  disabled,
  resetParams,
  fullWidth = false,
  other = {},
  isButton = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="flex-end"
      alignItems="center"
      mt={2}
      {...other}
    >
      <Button
        color="secondary"
        variant="outlined"
        onClick={() => {
          reset && reset(resetParams);
          if (callBackFunc) {
            callBackFunc();
          } else {
            navigate(-1);
          }
        }}
        disabled={!!disabled}
        fullWidth={fullWidth}
      >
        {t("common.buttons.cancel")}
      </Button>
      <Button
        type={isButton ? "button" : "submit"}
        variant="contained"
        onClick={handleSubmit}
        color="secondary"
        fullWidth={fullWidth}
        disabled={!!disabled}
      >
        {t("common.buttons.save")}
      </Button>
    </Stack>
  );
};

export default AddClearButtons;
